import React from 'react';
import { useHistory } from 'react-router-dom';
import { ApButtonSecondary, ApCheckbox } from '@alixpartners/ui-components';

import {
	NavWrapper,
	Divider,
	ControlGroup,
	CheckboxLabel,
} from './InitiativesToWavesAllocation.styles';

const MAX_WAVES_COUNT = 10;

export const SecondaryNav = ({
	waves = [],
	createWave,
	hideAllocatedInitiatives,
	onHideAllocatedInitiativesChange,
}) => {
	const history = useHistory();

	return (
		<NavWrapper>
			<ApButtonSecondary
				iconName="baseline_arrow_back"
				onClick={() => {
					const backUrl = '/waves';

					history.push(backUrl);
				}}
			>
				Save and back
			</ApButtonSecondary>

			<ControlGroup>
				<ApCheckbox
					onChange={onHideAllocatedInitiativesChange}
					checked={hideAllocatedInitiatives}
				>
					<CheckboxLabel>Hide initiatives allocated to a wave</CheckboxLabel>
				</ApCheckbox>
			</ControlGroup>
			<Divider />
			<ApButtonSecondary
				onClick={createWave}
				iconName="baseline_add"
				disabled={MAX_WAVES_COUNT <= waves.length}
			>
				Add wave
			</ApButtonSecondary>
		</NavWrapper>
	);
};

export default SecondaryNav;
